import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import {
  fetchTotalAnalytics,
  clearTotalAnalytics,
} from 'redux/analytics/actions';
import { toThousandSeparator } from 'utils/common';

import { Loader } from 'semantic-ui-react';
import AnalyticsSection from 'components/dashboard/analytics-content/AnalyticsSection';
import MetricItem from 'components/dashboard/analytics-content/AnalyticsMainMetrics/MetricItem';

import './AnalyticsMainMetrics.css';

const AnalyticsMainMetrics = ({
  date,
  label,
  analyticsTotal,
  analyticsTotalError,
  fetchTotalAnalytics,
  clearTotalAnalytics,
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    fetchTotalAnalytics(date);
    return () => clearTotalAnalytics();
  }, [date]);

  if (analyticsTotalError) {
    return null;
  }

  const renderData = () => {
    if (!analyticsTotal) {
      return null;
    }
    return (
      <div className="analytics-main-metrics-row-wrapper">
        <MetricItem
          title={t("Views")}
          data={`${toThousandSeparator(analyticsTotal.views)}`}
          label={label}
          helper={
            { id: 'metric__views', text: t("Metric shows how many times a particular page / link was viewed") }
          }
        />
        <MetricItem
          title={t("Unique Visitors")}
          data={`${toThousandSeparator(analyticsTotal.visitors)}`}
          label={label}
          helper={
            { id: 'metric__unique_visitors', text: t("Metric shows how many unique visitors visited a particular page / link") }
          }
        />
        <MetricItem
          title={t("Clicks")}
          data={`${toThousandSeparator(analyticsTotal.clicks)}`}
          label={label}
          helper={
            { id: 'metric__clicks', text: t("Metric shows how many times visitors clicked on the particular page / link") }
          }
        />
        <MetricItem
          title="CTR"
          data={`${analyticsTotal.ctr}%`}
          label={label}
          helper={
            { id: 'metric__avg_ctr', text: t("CTR = Clicks / Views") }
          }
        />
      </div>
    );
  };

  return (
    <AnalyticsSection
      className={`analytics-main-metrics__component ${!analyticsTotal ? 'loading' : ''}`}
    >
      <div className="analytics-main-metrics-row">
        {renderData()}
        <Loader active={!analyticsTotal} />
      </div>
    </AnalyticsSection>
  );
};

AnalyticsMainMetrics.propTypes = {
  date: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
  analyticsTotal: PropTypes.oneOfType([PropTypes.object]),
  analyticsTotalError: PropTypes.oneOfType([PropTypes.object]),
  fetchTotalAnalytics: PropTypes.func,
  clearTotalAnalytics: PropTypes.func,
};
AnalyticsMainMetrics.defaultProps = {
  date: null,
  label: null,
  analyticsTotal: null,
  analyticsTotalError: null,
  fetchTotalAnalytics: null,
  clearTotalAnalytics: null,
};

const mapStateToProps = state => ({
  analyticsTotal: state.analyticsReducer.analyticsTotal,
  analyticsTotalError: state.analyticsReducer.analyticsTotalError,
});

export default connect(
  mapStateToProps,
  {
    fetchTotalAnalytics,
    clearTotalAnalytics,
  },
)(AnalyticsMainMetrics);
